import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'interviewsList';
const initialState = {
  searchTerm: null,
  filters: {
    name: [],
    contact_id: [],
    note_taker_enabled: [],
    ats_department_id: [],
    ats_office_id: [],
    scorecard_status: [],
    ends_before: [],
    location: [],
    isFilterApplied: false,
  },
  currentTab: 'all',
  currentView: 'card',
  page: {
    number: 0,
    offset: 0,
    limit: 20,
  },
  sort: {
    label: 'Interview created date (Newest to oldest)',
    value: 'desc',
    element: 'created_at',
    order: 'desc',
  },
};

const { reducer, actions: interviewsListActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    resetJobState: (state, { payload: { key } }) => {
      state[key] = { ...initialState[key] };
    },

    applySort: (state, { payload }) => {
      state.sort = payload;
    },

    applyFilter: (state, { payload }) => {
      const { key, value } = payload;
      state.filters[key] = value;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
      state.page.offset = state?.page?.number * state?.page?.limit;
      state.searchTerm = '';
    },

    applyCurrentView: (state, { payload: { view } }) => {
      state.currentView = view;
    },

    applyCurrentTab: (state, { payload }) => {
      const { id } = payload;
      if (id) {
        state.currentTab = id;
        state.page = { ...initialState.page };
      }
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters[key] = initialState.filters[key];
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = Object.values(state.filters).some(
        (filter) => filter !== initialState.filters[key]
      );
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters };
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    restoreFilters: (state, { payload }: { payload: { filters: Record<string, unknown> } }) => {
      const { filters } = payload;
      Object.entries(filters).forEach(([key, value]) => {
        if (key !== 'isFilterApplied') {
          state.filters[key] = value;
        }
      });
      state.filters.isFilterApplied = true;
      state.page = { ...initialState.page };
    },

    clearData: (state) => {
      state.sort = { ...initialState.sort };
      state.currentView = initialState.currentView;
      state.searchTerm = '';
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = payload?.searchTerm?.length > 0;
    },
  },
});

export { interviewsListActions };
export default reducer;
